import {Action} from "redux-actions";
import {OnFailure, OnSuccess} from "../actionHelpers";
import {api} from "../../../api/api";
import {Dispatch} from "react-redux";
import {ACTIVITY_TEMPLATES_FETCHED, JOB_ACTIVITY_TEMPLATES_FETCHED} from "./actionType";
import DictionaryItem from "../../../model/dictionary/DictionaryItem";

/**
 * Activity templates fetched successful action.
 * @param {DictionaryItem[]} templates all activity templates from server.
 * @returns {Action<ACTIVITY_TEMPLATES_FETCHED>}
 */
function activityTemplatesFetched(templates: DictionaryItem[]): Action<ACTIVITY_TEMPLATES_FETCHED> {
	return {type: ACTIVITY_TEMPLATES_FETCHED, payload: {activityTemplates: templates}};
}

/**
 * Job activity templates fetched successful action.
 * @param {DictionaryItem[]} jobActivityTemplates all activity templates from server.
 * @returns {Action<JOB_ACTIVITY_TEMPLATES_FETCHED>}
 */
function jobActivityTemplatesFetched(jobActivityTemplates: DictionaryItem[]): Action<JOB_ACTIVITY_TEMPLATES_FETCHED> {
	return {type: JOB_ACTIVITY_TEMPLATES_FETCHED, payload: {jobActivityTemplates}};
}

/**
 * Fetch activity templates from server.
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function fetchActivityTemplates(onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.activityTemplateApi.fetchActivityTemplates().then(templates => {
			dispatch(activityTemplatesFetched(templates));
			onSuccess();
		}).catch(onFailure);
	};
}

/**
 * Fetch job activity templates from server.
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function fetchJobActivityTemplates(onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.activityTemplateApi.fetchJobActivityTemplates().then(templates => {
			dispatch(jobActivityTemplatesFetched(templates));
			onSuccess();
		}).catch(onFailure);
	};
}